import React from 'react';
import classnames from 'classnames';
import update from 'react-addons-update';
import LabelInput from './../forms/labelInput';
import RadioToggle from './../forms/RadioToggle';
import SelectOptions from './../forms/SelectOptions';

import ReactGA from 'react-ga';
ReactGA.initialize('UA-100475676-1');

let standardRating = 1.00,
    professionalRating = 0.65,
    whiteCollarRating = 0.65,
    highRiskRating = 1.50;

class SelectInsuranceCover extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      panel1Edit: '',
      panel2Edit: '',
      step2Inactive: true,
      value: null,
      coverType: 1,
      premium: '52',
      include: null,
      isToggleOn: null,
      showInclude1: 'false',
      showInclude2: 'false',
      showInclude3: 'false',
      dollarAmount: '',
      unitAmount: '',
      insuranceCoverInputs: {
        deathCover: '',
        tpdCover: '',
        ipCover: '',
        itemsWaitPeriod: 0,
        itemsProtectionLength: 0
      },
      insuranceCoverShow: {
        deathCover: true,
        tpdCover: true,
        ipCover: true
      },
      results:{
        premiumDCTotal: '',
        premiumTPDTotal: ''
      },
      userInputs: {
        age: this.props.userInputs.age
      },
      disableNext: false,
      hasErrors: false,
      hasTPDInputErrors: false,
      hasIPInputErrors: false,
      IPfieldsComplete: false
    };

    this.changeCover = this.changeCover.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleEditClick = this.handleEditClick.bind(this);

    this.insuranceCoverShow = {
      deathCover: this.insuranceCoverShow.bind(this, 'deathCover'),
      tpdCover: this.insuranceCoverShow.bind(this, 'tpdCover'),
      ipCover: this.insuranceCoverShow.bind(this, 'ipCover')
    };

    this.insuranceInput = {
      deathCover: this.insuranceInput.bind(this, 'deathCover'),
      tpdCover: this.insuranceInput.bind(this, 'tpdCover'),
      ipCover: this.insuranceInput.bind(this, 'ipCover')
    };

    this.ipInput = {
      itemsWaitPeriod: this.ipInput.bind(this, 'itemsWaitPeriod'),
      itemsProtectionLength: this.ipInput.bind(this, 'itemsProtectionLength')
    };

    this.onDCblur = this.onDCblur.bind(this);
    this.onTPDblur = this.onTPDblur.bind(this);
    this.onIPblur = this.onIPblur.bind(this);
  }

  shouldComponentUpdate(nextProps, nextState) {
    return this.state.userInputs.age !== null;
  }

  onDCblur(e) {
    ReactGA.event({
      category: 'Tell us about your needs',
      action: 'User entered Death cover amount',
      label: 'How much Death cover do you need?',
      value: parseInt(e.target.value)
    });
  }

  onTPDblur(e) {
    ReactGA.event({
      category: 'Tell us about your needs',
      action: 'User entered Total and Permanent Disability cover amount',
      label: 'How much Total and Permanent Disability cover do you need?',
      value: parseInt(e.target.value)
    });
  }

  onIPblur(e) {
    ReactGA.event({
      category: 'Tell us about your needs',
      action: 'User entered Income Protection cover amount',
      label: 'How much Income Protection cover do you need?',
      value: parseInt(e.target.value)
    });
  }

  onIPWaitPeriodblur(e) {
    ReactGA.event({
      category: 'Tell us about your needs',
      action: 'User selected wait period',
      label: 'How long to wait for protection benefit?',
      value: parseInt(e.target.value)
    });
  }

  onIPProtectLengthblur(e) {
    ReactGA.event({
      category: 'Tell us about your needs',
      action: 'User selected protection length',
      label: 'How long to receive protection benefits?',
      value: parseInt(e.target.value)
    });
  }

  insuranceInput(propertyName, e) {
      const insuranceCoverInputs = this.state.insuranceCoverInputs;
      insuranceCoverInputs[propertyName] = e;
      this.setState({
        insuranceCoverInputs: insuranceCoverInputs
      }, () => this.props.callbackParent(this.state.insuranceCoverInputs));

      // set protection length and wait period if police
      if(this.props.userInputs.police === '1') {
        this.setState(update(
          // this.state.insuranceCoverInputs.itemsProtectionLength
          this.state, {
            insuranceCoverInputs: {
              itemsProtectionLength: {$set: '2'},
              itemsWaitPeriod: {$set: '180'}
            }
          }), () => this.props.callbackParent(this.state.insuranceCoverInputs));
      }
  }

  ipInput(propertyName, e) {
    const insuranceCoverInputs = this.state.insuranceCoverInputs;
    insuranceCoverInputs[propertyName] = e.target.value;
    this.setState({
    insuranceCoverInputs: insuranceCoverInputs
  }, () => this.props.callbackParent(this.state.insuranceCoverInputs));
  }

  insuranceCoverShow(propertyName, e) {
      const insuranceCoverShow = this.state.insuranceCoverShow;
      insuranceCoverShow[propertyName] = e;
      this.setState(prevState => ({
        isToggleOn: !prevState.isToggleOn
      }),() => this.props.callbackCoverShow(this.state.insuranceCoverShow));
  }

  changeCover(component, e) {
    this.setState({coverType: component});
  }

  handleClick(e) {
    e.preventDefault();
    ReactGA.event({
      category: 'Tell us about your needs',
      action: 'User clicked Next button'
    });

    this.setState({
      panel2Edit: true,
      step1Inactive: true,
      step2Inactive: true,
      step3Inactive: false
    },
    () => this.props.panel2Visible(this.state.step2Inactive),
    () => this.props.panel2Visible(this.state.step3Inactive),
    () => this.props.panel2Visible(this.state.panel2Edit));
  }

  hasErrors(e) {
    this.setState({
      hasErrors: e
    });
  }

  hasTPDInputErrors(e) {
    this.setState({
      hasTPDInputErrors: e
    });
  }

  hasIPInputErrors(e) {
    this.setState({
      hasIPInputErrors: e
    });
  }

  itemsWaitPeriod() {
    if (this.state.insuranceCoverInputs.itemsWaitPeriod > 0) {
      return ('*Or Accrued Sick leave whichever is longer');
    }
  }

  getIp() {

      const getIPvalue = (component) => this.insuranceInput.ipCover(component);
      const getIPerrors = (e) => this.hasIPInputErrors(e);

      if(this.props.userInputs.police == '1') {
        return (
        <span>
        <LabelInput validateMinMaxIP label={'How much income protection cover do you need per month (to the nearest $500)?'}
        pattern={"[0-9]*"}
        toolTip={'QSuper offers income protection in units of $500 per month in cover. Please be aware your cover can never be more than 87.75% of your pre-disability income, of which 12.75% goes to your super.'}
        labelSubtext={'Your cover can be up to 87.75% of your income. Consider expenses like mortgage or rental payments, household bills, transport costs and groceries.'}
        callbackParent={getIPvalue} roundOffValue={500} type={'number'}
        callbackError={getIPerrors}
        onBlur={this.onIPblur}
        />
        <div className="control">
          <label>How long could you afford to wait to receive your first income protection benefit?</label>
          <p className="label-subtext">Your cover can be up to 87.75% of your income. Consider expenses like mortgage or rental payments, household bills, transport costs and groceries.</p>
          <span className="static-input">{this.props.police.protectionLength}</span>
        </div>
        <div className="control">
          <label>How long would you like to receive income protection benefits?</label>
          <p className="label-subtext">(Please note: your payments would stop should your eligibility end within your selected benefit period.)</p>
          <span className="static-input">{this.props.police.waitPeriod}</span>
        </div>
        </span>);
      } else {
        return (
        <span>
        <LabelInput validateMinMaxIP
        pattern={"[0-9]*"}
        toolTip={'QSuper offers income protection in units of $500 per month in cover. Please be aware your cover can never be more than 87.75% of your pre-disability income, of which 12.75% goes to your super.'}
        label={'How much income protection cover do you need per month (to the nearest $500)?'}
        labelSubtext={'Your cover can be up to 87.75% of your income. Consider expenses like mortgage or rental payments, household bills, transport costs and groceries.'}
        callbackParent={getIPvalue}
        roundOffValue={500}
        type={'number'}
        callbackError={getIPerrors}
        onBlur={this.onIPblur}
        />
        <SelectOptions
        items={this.props.itemsWaitPeriod}
        handleChange={this.ipInput.itemsWaitPeriod}
        controlLabel={'How long could you afford to wait to receive your first income protection benefit?'}
        labelSubtext={'Consider sick leave, savings and/or other leave entitlements.'}
        simpleSelectSubtext={this.itemsWaitPeriod()}
        onBlur={this.onIPWaitPeriodblur}/>
        <SelectOptions items={this.props.itemsProtectionLength}
        handleChange={this.ipInput.itemsProtectionLength}
        controlLabel={'How long would you like to receive income protection benefits?'}
        labelSubtext={'(Please note: your payments would stop should your eligibility end within your selected benefit period.)'}
        onBlur={this.onIPProtectLengthblur}
        />
        </span>);
      }
  }

  handleEditClick(e) {
    e.preventDefault();
    ReactGA.event({
      category: 'Tell us about your needs',
      action: 'User clicked Edit button'
    });
    this.setState({
      panel2Edit: false,
      step1Inactive: true,
      step2Inactive: false,
      step3Inactive: true
    }, () => this.props.panel2Visible(this.state.step2Inactive));
  }


  enableNextButton() {

      let enable = (<a href="#" disabled={false} className={classnames('next-button', {inactive: this.props.step1Inactive})} onClick={this.handleClick}>Next</a>);
      let disable =(<a href="#" disabled={true} className={classnames('next-button', {inactive: this.props.step1Inactive})} onClick={this.handleClick}>Next</a>);

      if(this.state.hasErrors !== true && this.state.hasIPInputErrors !== true && this.state.hasTPDInputErrors !== true) {
        if(this.props.userInputs.police === "0") {
          if(this.state.insuranceCoverInputs.ipCover === '' && (this.state.insuranceCoverInputs.deathCover !== '' || this.state.insuranceCoverInputs.tpdCover !== '')) {
            return enable;
          } else if(this.state.insuranceCoverInputs.ipCover > 1 && this.state.insuranceCoverInputs.itemsProtectionLength !== 0 && this.state.insuranceCoverInputs.itemsWaitPeriod !== 0) {
            return enable;
          } else {
            return disable;
          }
        } else if(this.props.userInputs.police === '1') {
          if(this.state.insuranceCoverInputs.ipCover !== '' || this.state.insuranceCoverInputs.deathCover !== '' || this.state.insuranceCoverInputs.tpdCover !== '') {
            return enable;
          } else {
            return disable;
          }
        }
      } else {
        return disable;
      }
  }

  render() {
    // initalize callbacks
    const getTPDvalue = (component) => this.insuranceInput.tpdCover(component);
    const getDCvalue = (component) => this.insuranceInput.deathCover(component);
    const getDCerrors = (e) => this.hasErrors(e);
    const getTPDerrors = (e) => this.hasTPDInputErrors(e);

    return (
      <div className={classnames('panel', {inactive: this.props.step2Inactive})}>
        <div className="panel--title">
          <h2>2. Tell us about your needs</h2>
        </div>
        <div className={classnames('panel--content', {'edit-mode': this.props.panel2Edit})}>
        <p>Let us know how much insurance cover you think you need. Try our <a href="https://qsuper.qld.gov.au/calculators-and-forms/calculators/insurance/insurance-needs/" target="_blank">insurance needs analysis</a> if you need help.</p>
          <div className="panel--sub-content">
          <span className="dc-icon"></span>
            <h3>Death cover</h3>
            <p>Death insurance pays out a lump sum to your beneficiaries in the event of your death, or to yourself for a terminal illness.<br/> <a href="https://qsuper.qld.gov.au/deathinsurance" target="_bank">More information about death insurance</a>.</p>
            <LabelInput
            validateMinMaxDCTPD
            label={'How much cover do you think your family would need if you were to die (to the nearest $1,000)?'}
            labelSubtext={'Consider the cost of mortgage or personal loan repayments, hospital fees, funeral costs and other expenses.'}
            roundOffValue={1000}
            callbackParent={getDCvalue}
            callbackError={getDCerrors}
            type={'number'}
            pattern={"[0-9]*"}
            onBlur={this.onDCblur}/>

          </div>
          {
            this.props.userInputs.age < '65'
            ?
            <div>
              <div className="panel--sub-content">
                <span className="tpd-icon"></span>
                <h3>Total and Permanent Disability cover</h3>
                <p>This insurance pays out a lump sum if you suffer a total and permanent disability due to an illness or injury.<br/> <a href="https://qsuper.qld.gov.au/tpdinsurance" target="_bank">More information about total and permanent disability cover</a>.</p>
                <LabelInput
                validateMinMaxDCTPD
                label={'How much cover would you need if you could never work again due to a total and permanent disability (to the nearest $1,000)?'}
                labelSubtext={'Consider the cost of mortgage or personal loan repayments, medical care and other expenses.'}
                callbackParent={getTPDvalue}
                callbackError={getTPDerrors}
                roundOffValue={1000}
                type={'number'}
                pattern={"[0-9]*"}
                onBlur={this.onTPDblur}/>
              </div>

              <div className="panel--sub-content">
              <span className="ip-icon"></span>
                <h3>Income Protection cover</h3>
                <p>Income protection pays you a regular income stream if you’re temporarily unable to work due to an injury or illness.<br/> <a href="https://qsuper.qld.gov.au/incomeprotection" target="_bank">More information about income protection</a>.</p>
                  {
                    this.props.userInputs
                    ? this.getIp()
                    : null
                  }
              </div>
              </div>
              : null
            }
        </div>
        {
          this.props.panel2Edit
          ? <a href="" className="panel--edit" onClick={this.handleEditClick}>Edit</a>
          : null
        }
        {
          !this.props.step2Inactive
          ? this.enableNextButton()
          : null
        }
      </div>
    );
  }
}

SelectInsuranceCover.defaultProps = {
  panel2Steps: true,
  userInputs: {
    age: ''
  },
  itemsProtectionLength: [
    {value: 0, label: ""},
		{value: 2, label: "2 years"},
		{value: 5, label: "5 years"},
    {value: 65, label: "Until age 65"}
	],
  itemsWaitPeriod: [
    {value: 0, label: ""},
    {value: 30, label: "30 days*"},
    {value: 60, label: "60 days*"},
    {value: 90, label: "90 days*"}
  ],
  police: {
    protectionLength: '180 days',
    waitPeriod: '2 years'
  },
  callbackParent: function(){},
  callbackCoverShow: function(){},
  panel2Visible: function(){},
  step1Inactive: true,
  step2Inactive: false,
  panel2Edit: false
};

SelectInsuranceCover.propTypes = {
  callbackParent: React.PropTypes.func.isRequired,
  callbackCoverShow: React.PropTypes.func.isRequired,
  panel2Visible: React.PropTypes.func.isRequired,
  police: React.PropTypes.shape({
      protectionLength: '',
      waitPeriod: ''
    }),
  userInputs: React.PropTypes.shape({
      // title: React.PropTypes.string
      age: '',
      police: '',
      protectionLength: '',
      waitPeriod: ''
    }),
  itemsWaitPeriod: React.PropTypes.array.isRequired,
  itemsProtectionLength: React.PropTypes.array.isRequired,
  step1Inactive: React.PropTypes.bool.isRequired,
  step2Inactive: React.PropTypes.bool.isRequired,
  panel2Edit: React.PropTypes.bool.isRequired
};

export default SelectInsuranceCover;



// WEBPACK FOOTER //
// ./src/components/panels/SelectInsuranceCover.js